<template>
    <views class="map">
        <nav-bar
            title="门店分布"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <filter-bar
            :list="markers"
            @citychange="onCityChange"
            @map="handleShop"
            @doQuery="getShopList">
        </filter-bar>
        <views class="map-body">
            <!-- 地图 -->
            <el-amap
                ref="map"
                class="amap-box"
                :vid="'shop-detail'"
                :plugin="plugin"
                :center="mapCenter"
                :zoom="12">
                <!-- 标记 -->
                <el-amap-marker
                    v-for="(marker, index) in markers"
                    :vid="index"
                    :key="index"
                    :position="marker.position"
                    :events="marker.events">
                </el-amap-marker>
            </el-amap>
        </views>
        <views class="line"></views>
        <views class="empty">{{ emptyTitle }}</views>
    </views>
</template>

<script>
import FilterBar from '../shop/FilterBar'
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    components: {
        NavBar,
        FilterBar
    },
    mixins: [tools],
    props: {
    },
    data() {
        return {
            shopLoading: true,
            markers: [],
            mapCenter: [],
            plugin: []
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        emptyTitle() {
            return this.shopLoading ? '门店信息加载中.....' : '该区域暂无门店'
        }
    },
    mounted() {
        this.getShopList({ provinceId: this.$route.query.pid || '', cityId: this.$route.query.cid || '', posP: this.$route.query.posP, posC: this.$route.query.posC })
    },
    methods: {
        onCityChange() {

        },
        onClickLeft() {
            this.windowPush(`/shop?posP=${this.query.posP}&posC=${this.query.posC}&pid=${this.query.pid}&cid=${this.query.cid}`)
        },
        // 门店列表
        handleShop({ posP, posC }) {
            this.windowPush(`/shop?posP=${posP}&posC=${posC}`)
        },
        // 导航
        handleAddr(longitude, latitude, name) {
            this.windowPush(`/map-navigation?endLng=${longitude}&endLat=${latitude}&toName=${name}&posP=${this.query.posP}&posC=${this.query.posC}`)
        },
        // 获取门店列表
        getShopList({ provinceId, cityId, posP, posC }) {
            const params = {
                page: 1,
                page_size: 1000
            }
            if (provinceId) params.provinceId = provinceId
            if (provinceId && cityId) params.cityId = cityId
            this.shopLoading = true
            this.markers = []
            api.getShopList(params).then((res) => {
                if (res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.markers.push({
                            position: [parseFloat(item.longitude), parseFloat(item.latitude)],
                            events: {
                                click: () => {
                                    this.handleAddr(parseFloat(item.longitude), parseFloat(item.latitude), item.name)
                                }
                            },
                            visible: true,
                            draggable: false
                        })
                        // this.markers = [[104.026752, 30.586704], [104.188303, 30.529981], [103.909469, 30.640908]]
                    })
                    if (this.markers.length > 0) this.mapCenter = this.markers[0].position
                    setTimeout(() => {
                        // 设置地图缩进范围
                        this.$refs.map.$$getInstance().setFitView()
                    }, 400)
                } else if (res.data.list.length === 0) {
                    this.$notify('暂无门店信息')
                }
                this.shopLoading = false
            }).catch(() => {
                this.shopLoading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
